export const CTA_TYPE = {
  UNJOINED: "unjoined",
  JOINED: "joined",
  JOINED_CLOSED: "joined_closed",
  CLOSED: "closed",
  FULL: "full",
  DEFAULT: "default",
} as const;
